module.exports = __webpack_public_path__ + "img/logo.48ac063b.png";